import Industrial from "./Industrial";

export default Industrial;
